export enum CARRINHO_STEP {
  INGRESSO = 1,
  DATA = 2,
  TIPO_INGRESSO = 3,
  IDENTIFICACAO = 4,
  PAGAMENTO = 5,
  CONFIRMACAO = 6,
}
